import React, { useState } from 'react';
import { Check, AlertCircleIcon } from 'lucide-react';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setIsError(false);
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(Object.fromEntries(formData))
      });
      const data = await response.json().catch(() => null);
      if (response.ok && data && data.success) {
        setIsSuccess(true);
        form.reset();
        setTimeout(() => setIsSuccess(false), 5000);
      } else {
        console.error('Web3Forms error:', data);
        setIsError(true);
      }
    } catch (err) {
      console.error('Web3Forms network error:', err);
      setIsError(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section className="w-full bg-black py-20 px-4 border-t border-zinc-900" id="contact-form" data-id="element-92" data-mp="37otayfymes1">
      <div className="max-w-3xl mx-auto" data-id="element-93" data-mp="86rnfnuej0l8">
        <div className="text-center mb-12" data-id="element-94" data-mp="36mu7vwkixp03">
          <h2 className="text-4xl md:text-5xl font-black uppercase mb-4" data-id="element-95" data-mp="36o5dm1xj56tu">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-sky-300 via-blue-400 to-blue-600" data-id="element-96" data-mp="3bmgpsjbartf8">
              Contact Us
            </span>
          </h2>
          <div className="h-1 w-24 bg-blue-500 mx-auto rounded-full shadow-[0_0_10px_rgba(59,130,246,0.8)]" data-id="element-97" data-mp="3kmlkbsve6xbz" />
          <p className="text-2xl md:text-4xl mt-6 font-semibold bg-clip-text text-transparent bg-gradient-to-b from-sky-300 via-blue-400 to-blue-600" data-id="element-98" data-mp="vv13e94xou4g">
            Fill out the form and we will send you a custom quote.
          </p>
        </div>

        <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-xl" data-id="element-99" data-mp="2wylk9eplo8ct">
          {isSuccess ? <div className="flex flex-col items-center justify-center py-12 text-center animate-in fade-in zoom-in duration-500" data-id="element-100" data-mp="2rzigdxlcw86f">
              <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-101" data-mp="30xklao87nkyz">
                <Check className="w-8 h-8 text-green-500" data-id="element-102" data-mp="2d7qa0b3ji4gu" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-103" data-mp="2976c35b56wtn">
                Message Sent!
              </h3>
              <p className="text-gray-500" data-id="element-104" data-mp="2mykwngkp762t">
                Thank you for reaching out. Mike will get back to you shortly.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-105" data-mp="2i5hzyzkmjgie">
              {/* Hidden Web3Forms config fields */}
              <input type="hidden" name="access_key" value="117a1b08-1717-47b9-b0bd-edf47d626a50" data-id="element-106" data-mp="1pix9e1bz38fw" />
              <input type="hidden" name="subject" value="New Quote Request - Mike's Pro Detail" data-id="element-107" data-mp="50wiy42wq3nl" />
              <input type="hidden" name="from_name" value="Mike's Pro Detail Website" data-id="element-108" data-mp="9rl99g2uoul5" />

              {isError && <div className="flex items-center gap-3 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700" data-id="element-109" data-mp="3s5krociznc72">
                  <AlertCircleIcon className="w-5 h-5 flex-shrink-0" data-id="element-110" data-mp="yrqh8o73d2j" />
                  <p className="text-sm font-medium" data-id="element-111" data-mp="wx37npgb8va">
                    Something went wrong. Please try again or call (818)
                    381-9905 directly.
                  </p>
                </div>}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-112" data-mp="eqoeb0itz0t4">
                <div className="space-y-2" data-id="element-113" data-mp="eqg4jhi08bm5">
                  <label htmlFor="name" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-114" data-mp="jp9gh5hn7uk7">
                    Name *
                  </label>
                  <input type="text" id="name" name="name" required className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors" placeholder="John Doe" data-id="element-115" data-mp="2zj9sn6b15jcd" />
                </div>
                <div className="space-y-2" data-id="element-116" data-mp="3axctzwu58o1h">
                  <label htmlFor="email" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-117" data-mp="3ay4nn246kbp4">
                    Email *
                  </label>
                  <input type="email" id="email" name="email" required className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors" placeholder="john@example.com" data-id="element-118" data-mp="6jmz2zg73xjf" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-119" data-mp="3oo87xnji1vbx">
                <div className="space-y-2" data-id="element-120" data-mp="2i9paym8iu5gy">
                  <label htmlFor="phone" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-121" data-mp="2i6kzr4wn29gs">
                    Phone *
                  </label>
                  <input type="tel" id="phone" name="phone" required autoComplete="tel" pattern="[\d\s\-\+\(\)\.]{7,}" className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors" placeholder="(555) 123-4567" data-id="element-122" data-mp="236z3fs8j05wa" />
                </div>
                <div className="space-y-2" data-id="element-123" data-mp="2lwx7lx97deun">
                  <label htmlFor="vehicle" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-124" data-mp="2lvvy3x7u50f1">
                    Make / Model *
                  </label>
                  <input type="text" id="vehicle" name="vehicle" required className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors" placeholder="e.g. 2023 Tesla Model 3" data-id="element-125" data-mp="2vvmq9s8xb3by" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-126" data-mp="yefng39bcbak">
                <label htmlFor="source" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-127" data-mp="yfh0uedsx9vg">
                  Where did you hear about us?
                </label>
                <input type="text" id="source" name="source" className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors" placeholder="Google, Yelp, Friend, etc." data-id="element-128" data-mp="18dwqse13ed3d" />
              </div>

              <div className="space-y-2" data-id="element-129" data-mp="1cdxeyqdzu2nm">
                <label htmlFor="service" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-130" data-mp="1r33fqishc0xm">
                  Type of Service *
                </label>
                <select id="service" name="service" required className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors appearance-none" style={{
              backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%239ca3af' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
              backgroundPosition: 'right 0.5rem center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '1.5em 1.5em',
              paddingRight: '2.5rem'
            }} data-id="element-131" data-mp="1m6mf4p43fu3n">
                  <option value="" disabled selected data-id="element-132" data-mp="20qp88un6xxte">
                    Select a service...
                  </option>
                  <option value="Basic Wash" data-id="element-133" data-mp="1n0dfctis7v17">Basic Wash</option>
                  <option value="Wash & Wax" data-id="element-134" data-mp="1r15mnh83fpuu">Wash & Wax</option>
                  <option value="Full Detail" data-id="element-135" data-mp="1r1p8h90v6ye5">Full Detail</option>
                  <option value="Interior Detail" data-id="element-136" data-mp="1d14my53keogy">Interior Detail</option>
                  <option value="Engine Bay Cleaning" data-id="element-137" data-mp="1i07sdqngiwpg">
                    Engine Bay Cleaning
                  </option>
                  <option value="Others" data-id="element-138" data-mp="1xiqwwaosuuq3">Others</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-139" data-mp="1sj5zi4pa2ufh">
                <label htmlFor="message" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-140" data-mp="1sk7cwftrnt0d">
                  Message
                </label>
                <textarea id="message" name="message" rows={4} className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors resize-none" placeholder="Tell us more about what you need..." data-id="element-141" data-mp="1jhoatxxt1kf6"></textarea>
              </div>

              <button type="submit" disabled={isSubmitting} className="w-full py-4 bg-gradient-to-r from-blue-500 to-blue-700 text-white font-bold text-lg uppercase tracking-wider rounded-lg hover:from-blue-400 hover:to-blue-600 transition-all shadow-[0_0_20px_rgba(59,130,246,0.3)] hover:shadow-[0_0_30px_rgba(59,130,246,0.5)] disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-142" data-mp="10s87l2uqjdv2">
                {isSubmitting ? <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-143" data-mp="37exfgou7okl5">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-144" data-mp="3ggwxnkgypupo"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-145" data-mp="2jrpc4cgcfllr"></path>
                    </svg>
                    Sending...
                  </> : 'Send Message'}
              </button>
            </form>}
        </div>
      </div>
    </section>;
}